<template>
  <div>
    <div>
      <section v-if="!loaded">
        <article class="media">
          <figure class="media-left">
            <p class="image is-64x64">
              <b-skeleton circle width="64px" height="64px"></b-skeleton>
            </p>
          </figure>
          <div class="media-content">
            <div class="content">
              <p>
                <b-skeleton active></b-skeleton>
                <b-skeleton height="80px"></b-skeleton>
              </p>
            </div>
            <nav class="level is-mobile">
              <div class="level-left">
                <a class="level-item">
                  <span class="icon is-small">
                    <b-skeleton></b-skeleton>
                  </span>
                </a>
                <a class="level-item">
                  <span class="icon is-small">
                    <b-skeleton></b-skeleton>
                  </span>
                </a>
              </div>
            </nav>
          </div>
        </article>
      </section>
      <div class="flow-content" v-else>
        <ApplicationFlowIntro
          v-if="application.currentPosition === FLOW_POSITION.INTRO"
          :flow-config-steps="flowSteps"
          :application-id="application.id"
        />

        <ApplicationFlowStep
          v-if="application.currentPosition === FLOW_POSITION.FLOW"
          :step="currentStep"
          :applicationId="application.id"
        />

        <ApplicationFlowOverview
          v-if="application.currentPosition === FLOW_POSITION.OVERVIEW"
          :steps="flowSteps"
        />

        <ApplicationFlowDataValidation
          v-if="application.currentPosition === FLOW_POSITION.DATA_VALIDATION"
        />

        <ApplicationFlowKYCPreparation
          v-if="
            application.currentPosition === FLOW_POSITION.KYC_PREPARATION ||
            application.currentPosition === FLOW_POSITION.SIGN_PREPARATION
          "
          :position="application.currentPosition"
        />

        <ApplicationFlowKYCChoose
          v-if="
            application.currentPosition === FLOW_POSITION.KYC_CHOOSE ||
            application.currentPosition === FLOW_POSITION.SIGN_CHOOSE
          "
          :position="application.currentPosition"
        />

        <ApplicationFlowWaitingRoom
          v-if="
            application.currentPosition === FLOW_POSITION.KYC_WAITING ||
            application.currentPosition === FLOW_POSITION.SIGN_WAITING
          "
          :position="application.currentPosition"
        />

        <ApplicationFlowContractCheck
          v-if="application.currentPosition === FLOW_POSITION.CONTRACT_CHECK"
          :position="application.currentPosition"
        />

        <ApplicationFlowResult
          v-if="application.currentPosition === FLOW_POSITION.RESULT"
          :status="application.currentStatusResult"
        />

        <ApplicationFlowClosed
          v-if="application.currentPosition === APPLICATION_STATUS.CLOSED"
        />
      </div>

      <portal to="application-flow-navigator-destination">
        <ApplicationFlowNavigator
          v-if="loaded && application.currentPosition !== FLOW_POSITION.INTRO"
          :current-step-index="application.currentFlowIndex"
          :flow-position="application.currentPosition"
          :application-id="application.id"
          :steps="flowSteps"
        />
      </portal>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { APPLICATION_STATUS, FLOW_POSITION, USER_STATUS } from "../utils/const";
import { monify } from "../utils/util";

export default {
  name: "Application",
  title: "mp:page.application.title",
  components: {
    ApplicationFlowResult: () =>
      import("@/components/application/ApplicationFlowResult.vue"),
    ApplicationFlowDataValidation: () =>
      import("@/components/application/ApplicationFlowDataValidation.vue"),
    ApplicationFlowClosed: () =>
      import("@/components/application/ApplicationFlowClosed.vue"),
    ApplicationFlowContractCheck: () =>
      import("@/components/application/ApplicationFlowContractCheck.vue"),
    ApplicationFlowIntro: () =>
      import("@/components/application/ApplicationFlowIntro.vue"),
    ApplicationFlowStep: () =>
      import("@/components/application/ApplicationFlowStep.vue"),
    ApplicationFlowKYCPreparation: () =>
      import("@/components/application/ApplicationFlowKYCPreparation.vue"),
    ApplicationFlowKYCChoose: () =>
      import("@/components/application/ApplicationFlowKYCChoose.vue"),
    ApplicationFlowWaitingRoom: () =>
      import("@/components/application/ApplicationFlowWaitingRoom.vue"),
    ApplicationFlowOverview: () =>
      import("@/components/application/ApplicationFlowOverview.vue"),
    ApplicationFlowNavigator: () =>
      import("@/components/application/ApplicationFlowNavigator.vue"),
  },
  data() {
    return {
      monify,
      FLOW_POSITION,
      APPLICATION_STATUS,
      poll: null,
      imageUrl: null,
    };
  },
  computed: {
    ...mapGetters({
      application: "application/getActiveApplication",
      loaded: "application/loaded",
      flowSteps: "application/flow",
    }),
    currentStep() {
      return this.flowSteps.find(
        (fcs) => fcs.rowIndex === this.application.currentFlowIndex
      );
    },
  },
  methods: {
    async fetchStatus() {
      let currentStatus = this.$store.getters["profile/getStatus"];
      let newStatus = await this.$store.dispatch("profile/refreshUserStatus");
      if (currentStatus !== newStatus) {
        let backPath = this.$store.getters["profile/getBackPath"];
        if (backPath !== "/application") {
          this.loaded = false;
          await this.$router.push(backPath);
        }
      }
    },
  },
  async mounted() {
    await this.fetchStatus();

    if (!this.$store.getters["profile/isInState"](USER_STATUS.IN_FLOW)) {
      await this.$router.push(this.$store.getters["profile/getBackPath"]);
      return;
    }

    await this.$store.dispatch("application/loadEverything");
    this.poll = window.setInterval(async () => {
      await this.fetchStatus();
      await this.$store.dispatch("application/pollStatus");
    }, 30000);
  },
  beforeDestroy() {
    window.clearInterval(this.poll);
  },
};
</script>
<style scoped lang="scss">
.flow-header {
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
}

.flow-content {
  max-width: 560px;
  margin: 0 auto;
}

.offer-card {
  max-width: 560px;
  margin: 0 auto;
  position: relative;

  background: #ffffff;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  border-radius: 8px;

  &__label {
    position: absolute;
    top: -20px;
    left: 8px;
    font-size: 10px;
    color: white;
    background: #051c3a;
    padding: 4px 8px;
    border-radius: 4px 4px 0 0;
  }

  .offer-detail {
    background: #f3f5f9;
    border-radius: 4px;
    padding: 4px 8px;
    text-align: center;

    p:first-of-type {
      font-size: 10px;
    }

    p:last-of-type {
      font-size: 12px;
    }
  }
}

@media only screen and (min-width: 769px) {
  .offer-detail {
    p:first-of-type {
      font-size: 12px;
    }

    p:last-of-type {
      font-size: 14px;
    }
  }
}
</style>
